import axios from "axios";
import { format } from "date-fns";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { Employer, EmploymentStatus, PersonalDetails, TaxBracketInfo, TaxInformation, } from "./getClientProfile";
export const url = (clientId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/entity/client/${clientId}`
    : `https://middleware.uat.farther.com/entity/client/${clientId}`;
export const Client = z.object({
    advisorId: z.string(),
    contactInformation: z.object({
        emailAddress: z.string(),
    }),
    isAccreditedInvestor: z.boolean().nullable(),
});
export const PatchClient = z
    .object({
    advisorId: z.string(),
    emailAddress: z.string(),
    isAccreditedInvestor: z.boolean().nullable(),
    taxInformation: TaxInformation,
    netWorth: PersonalDetails.shape.estimatedNetWorthMillions,
    citizenship: PersonalDetails.shape.citizenship,
    incomeRange: PersonalDetails.shape.incomeRange,
    investorType: PersonalDetails.shape.investorType,
    investingObjective: PersonalDetails.shape.investingObjective,
    iraOutsideFarther: PersonalDetails.shape.iraOutsideFarther,
    "taxBracketInfo.taxBracketLTG": TaxBracketInfo.shape.taxBracketLTG,
    "taxBracketInfo.taxBracketOrdinary": TaxBracketInfo.shape.taxBracketOrdinary,
    "taxBracketInfo.capitalLossCarryover": TaxBracketInfo.shape.capitalLossCarryover,
    employmentDetails: z
        .object({
        employmentStatus: z.literal(EmploymentStatus.enum.Employed),
        employerName: Employer.shape.employerName,
        occupation: Employer.shape.occupation,
        startYear: Employer.shape.startYear,
        employerAddress: Employer.shape.employerAddress,
    })
        .or(z.object({
        employmentStatus: EmploymentStatus.exclude([
            EmploymentStatus.enum.Employed,
        ]),
    })),
})
    .partial()
    .strict();
export default async function patchClient(clientId, body, config) {
    const logBodies = Object.entries(body)
        .map(([key, value]) => `${key}:${value}`)
        .join("-");
    const dayCapture = format(new Date(), "yyyy-MM-dd:HH:mm:ss");
    const actorId = "advisorId" in config ? config.advisorId : config.clientId;
    const idemKey = `${clientId}_${actorId}_${logBodies}_${dayCapture}`;
    const { data } = await axios.patch(url(clientId), body, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...("clientId" in config && { Client: config.clientId }),
            Version: "20240626",
            "Idempotency-Key": idemKey,
        },
    });
    const decoded = Client.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[patchClient] Could not parse";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=patchClient.js.map